<template>
	<FontAwesomeIcon
		:class="iconClasses"
		:icon="['fad', 'spinner-third']"
		:transform="{ rotate: rotation }"
		@mouseover.prevent="onMouseOver"
		@mouseleave.prevent="onMouseLeave"
		@click.prevent="onClick"
	/>
</template>

<script>
/* eslint-disable no-magic-numbers */
export default {
	name: "TeamingSpinner",
	props: {
		isVisible: {
			type: Boolean,
			default: true,
		},
		isSpinning: {
			type: Boolean,
			default: false,
		},
		isResetting: {
			type: Boolean,
			default: false,
		},
		speed: {
			type: Number,
			default: 15,
		},
	},
	data() {
		return {
			rotation: 0,
			animationHandle: null,
		};
	},
	computed: {
		iconClasses() {
			return {
				"teaming-spinner": true,
				"teaming-spinner--visible": this.isVisible,
				"teaming-spinner--spinning": this.isSpinning,
				"teaming-spinner--resetting": this.isResetting,
			};
		},
	},
	methods: {
		haltAnimation() {
			if ( this.animationHandle ) {
				clearInterval( this.animationHandle );
				this.animationHandle = null;
				this.$emit( "stopped", {} );
			}
		},
		animate() {
			this.haltAnimation();
			this.animationHandle = setInterval( () => {
				if ( this.rotation === 350 ) {
					this.rotation = 0;
				} else {
					this.rotation += this.speed;
				}
				this.$emit( "rotated", { rotation: this.rotation, } );
			}, 50 );
		},
		onMouseOver() {
			this.$emit( "mouseover", {} );
		},
		onMouseLeave() {
			this.$emit( "mouseleave", {} );
		},
		onClick() {
			this.$emit( "click", {} );
		},
	},
	mounted() {
		if ( this.isSpinning ) {
			this.animate();
		}
	},
	updated() {
		if ( !this.isSpinning ) {
			this.haltAnimation();
		} else {
			this.animate();
		}
	},
	beforeDestroy() {
		this.haltAnimation();
	},
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
	0% { opacity: 0 }
	100% { opacity: 1 }
}

.teaming-spinner {
	@include font-and-line-for(0);
	cursor: pointer;
	display: none;
	--fa-primary-color: #{ $teaming-spinner-primary-color };
	--fa-secondary-color: #{ $teaming-spinner-secondary-color };
}

.teaming-spinner--visible {
	display: inline-block;
}

.teaming-spinner--spinning {
	cursor: wait;
}

.teaming-spinner--resetting {
	display: inline-block;
	* {
		animation-name: fadeIn;
		animation-duration: 1s;
		animation-fill-mode: forwards;
	}
}
</style>
